import script from "./ActiveFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ActiveFilter.vue?vue&type=script&setup=true&lang=js"

import "./ActiveFilter.vue?vue&type=style&index=0&id=0dab5b11&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dab5b11"]])

export default __exports__